import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { addRandomImageToReseller, addRandomImageToBusiness } from '@utilities/function-utils';
import { ResellerModel, RequestModel, BusinessModel, ReplyTemplateModel } from '@models/index';
import * as fromRoot from '@reducers/index'
import { ResellersActions, ReplyTemplateActions } from '@actions/index';

@Injectable({
    providedIn: 'root'
})
export class AdminFacadeService {

    constructor(private store: Store<any>) { }

    getIsTaskExecuting$(): Observable<boolean> {
        return this.store.select(fromRoot.getIsExecutedTaskReseller)
    }

    getResellers$(): Observable<ResellerModel[]> {
        return this.store
            .select(fromRoot.getResellers)
            .pipe(
                map(items => items
                    .map(addRandomImageToReseller)
                    .sort((a: ResellerModel, b: ResellerModel) => a.name.localeCompare(b.name))
                ),
            )
    }
    getSelectedReseller$(): Observable<ResellerModel> {
        return this.store.select(fromRoot.getSelectedResellerProfile)
    }
    getResellerById$(): Observable<ResellerModel> {
        return this.store.select(fromRoot.getResellerById)
    }
    searchResellers(payload: { page: number, size: number }) {
        const request: RequestModel = {
            params: `resellers?page=${payload.page}&size=${payload.size}`
        }
        this.store.dispatch(ResellersActions.searchResellers({ request }))
    }
    getResellerById(resellerId: string) {
        const request: RequestModel = {
            params: `resellers/${resellerId}`
        }
        this.store.dispatch(ResellersActions.getResellerById({ request }))
    }
    searchResellersByUser(resellerId: string) {
        const request: RequestModel = {
            params: `resellers/byUser/${resellerId}`
        }
        this.store.dispatch(ResellersActions.searchResellers({ request }))
    }
    searchResellersByQuery(payload: { page: number, size: number,query:string }) {
        const request: RequestModel = {
            params: `resellers/autocomplete?query=${payload.query}&page=${payload.page}&size=${payload.size}`
        }
        this.store.dispatch(ResellersActions.searchResellersByQuery({ request }))
    }

    createReseller(reseller: ResellerModel) {
        const request: RequestModel = {
            params: `resellers`,
            payload: reseller
        }
        this.store.dispatch(ResellersActions.createReseller({ request }))
    }
    editReseller(reseller: ResellerModel) {
        this.store.dispatch(ResellersActions.editReseller({ reseller }))
    }
    selectResellerProfile(reseller: ResellerModel) {
        this.store.dispatch(ResellersActions.selectResellerProfile({ reseller }))
    }
    searchMessagesByQuery(query: string) {
    }
    editBusinessByQuery(query: string) {
    }
    editResellersByQuery(query: string) {
    }
    editLocationByQuery(query: string) {
    }

    getReplyTemplate() {
        const request: RequestModel = {
            params: `reviewReplay`,
        }
        this.store.dispatch(ReplyTemplateActions.getReplyTemplate({ request }))
    }

    saveReplyTemplate(replyTemplate: ReplyTemplateModel) {
        const request: RequestModel = {
            params: `reviewReplay`,
            payload: replyTemplate
        }
        this.store.dispatch(ReplyTemplateActions.saveReplyTemplate({ request }))
    }

    getReplyTemplate$(): Observable<ReplyTemplateModel> {
        return this.store.select(fromRoot.getReplyTemplate)
    }
    setReplyTemplate(text: string) {
        this.store.dispatch(ReplyTemplateActions.setReplyTemplate({ text }))
    }

    getResellerCount$(): Observable<number> {
        return this.store.select(fromRoot.getResellerCount)
    }
}